export default () => ({
    advice: {
        marginBottom: 8,
    },
    footer: {
        marginTop: 6,
    },
});
